import { FragmentDeleteDialog } from '@app/modules/fragments/screens/delete/FragmentDeleteDialog';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Divider, IconButton, Menu } from '@mui/material';
import { MouseEvent, useState } from 'react';
import { useFragment } from '../hooks/useFragment';
import { FragmentViewDeleteMenuItem } from './FragmentViewDeleteMenuItem';
import { FragmentViewRegenerateMediaMenuItem } from './FragmentViewRegenerateMediaMenuItem';
import { Station } from '@app/core/types/stations';

interface FragmentViewOverflowActionsProps {
  station: Station;
}

/**
 * Overflow menu (three dots) for fragment view header: hosts secondary actions such as
 * regenerate media and delete. The delete dialog is rendered outside the Menu so closing
 * the menu does not unmount or dismiss the confirmation dialog.
 */
export function FragmentViewOverflowActions({ station }: FragmentViewOverflowActionsProps) {
  const { fragment } = useFragment();
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const menuOpen = Boolean(menuAnchor);

  function handleOpenMenu(event: MouseEvent<HTMLElement>) {
    setMenuAnchor(event.currentTarget);
  }

  function handleCloseMenu() {
    setMenuAnchor(null);
  }

  function handleRequestDelete() {
    handleCloseMenu();
    setDeleteDialogOpen(true);
  }

  return (
    <>
      <IconButton size="small" color="secondary" onClick={handleOpenMenu}>
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={menuAnchor} open={menuOpen} onClose={handleCloseMenu}>
        <FragmentViewRegenerateMediaMenuItem onAction={handleCloseMenu} />
        <Divider />
        <FragmentViewDeleteMenuItem onAction={handleRequestDelete} />
      </Menu>
      <FragmentDeleteDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        station={station}
        fragment={fragment}
      />
    </>
  );
}
